import { FormattedVerificationTransaction, VerificationTransaction } from "@idw-types/data/reports";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";

export const formatVerificationTransactions = (
    verificationTransactions: Array<VerificationTransaction>,
    axnRelyingParties: Array<AxnRelyingParty>
): Array<FormattedVerificationTransaction> => {
    return verificationTransactions.map(vt => formatVerificationTransaction(vt, axnRelyingParties));
};

export const formatVerificationTransaction = (
    verificationTransaction: VerificationTransaction,
    axnRelyingParties: Array<AxnRelyingParty>
): FormattedVerificationTransaction => {
    let date = null;
    if (verificationTransaction.date) {
        date = new Date(parseInt(verificationTransaction.date));
    }
    const relyingParty = axnRelyingParties.find(rp => rp.id === verificationTransaction.relyingParty);
    return {
        apikey: verificationTransaction.apikey,
        credential: verificationTransaction.credential,
        date: date,
        policyDecision: verificationTransaction.policyDecision,
        relyingParty: relyingParty,
        score: verificationTransaction.score,
        serviceName: verificationTransaction.serviceName,
        transactionID: verificationTransaction.transactionID,
        userMBUN: verificationTransaction.userMBUN,
        appID: verificationTransaction.appID
    };
};